import { Dispatch, SetStateAction } from "react";
import styles from "./CartFormCards.module.css";
import { Action } from "../../../Bundles/Types";
import { CartConfigInterface } from "../../CartTypes";
import { Checkbox, Divider, FormLayout, RadioButton, RangeSlider, Select, TextField } from "@shopify/polaris";
import { FONTS } from "../../../../utilities/fonts";
import {
    AvailableCartDrawerTemplates,
    AvailableCartFooterLayouts,
    FontStyles,
    HeaderHeightOptions,
} from "../../../Bundles/constants";
import NewCustomColorPicker from "../../../../components/NewCustomColorPicker/NewCustomColorPicker";
import FontsSelect from "../../../../components/FontsSelect";
import CartTemplatesTheme from "./CartTemplatesTheme";
import { KINNBABY_SHOP_URL } from "../../../../utilities/constants";

const CartDesignCard = ({
    fields,
    dispatchCartConfig,
    cartConfig,
    showCartPreview,
    setConfig,
}: {
    setConfig: Dispatch<SetStateAction<CartConfigInterface>>;
    fields: any;
    showCartPreview: boolean;
    cartConfig: CartConfigInterface;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const {
        selected_drawer_template,
        selected_drawer_footer_layout,
        cart_design: {
            cart_bg_color,
            cart_font_family,
            cart_width,

            // Header
            header_bg_color,
            header_title_color,
            header_title_underline_color,
            header_title_underline_color_gradient_status,
            header_title_underline_color_gradient_direction,
            header_title_underline_color_gradient_color,
            header_quantity_color,
            header_height,
            close_button_color,

            // CartLine Card
            cartline_card_bg_color,
            cartline_card_text_color,
            cartline_card_save_text_color,
            cartline_card_qty_color,
            cartline_card_discount_bg_color,
            cartline_card_discount_text_color,
            cartline_card_title_size,
            cartline_card_title_style,
            cartline_card_properties_size,
            cartline_card_properties_style,
            cartline_card_price_size,
            cartline_card_price_style,
            cartline_card_compared_price_size,
            cartline_card_compared_price_style,
            cartline_card_save_text_size,
            cartline_card_save_text_style,

            // Footer
            footer_text_color,
            footer_text_size,
            footer_text_style,
            footer_compare_at_color,
            footer_compare_at_size,
            footer_compare_at_style,
            footer_secondary_text_color,
            footer_secondary_text_size,
            footer_secondary_text_style,
            footer_bg_color,
            footer_button_radius,
            footer_button_cta_text_size,
            footer_custom_shipping_button_color,
            footer_button_cta_text_style,
            footer_button_bg_color,
            footer_button_text_color,
            footer_button_border_color,
            footer_button_hover_border_color,
            footer_button_bg_hover_color,
            footer_button_text_hover_color,
            footer_discount_tag_bg_color,
            footer_discount_tag_text_color,
        },
    } = fields;

    const userShopname = shopify.config?.shop;
    return (
        <>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>General</div>
                <FormLayout>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                        }}
                    >
                        {" "}
                        <div className={styles.cardSubLabel} style={{ marginBottom: -5 }}>
                            Layout
                        </div>
                        <CartTemplatesTheme
                            fields={fields}
                            cartConfig={cartConfig}
                            dispatchCartConfig={dispatchCartConfig}
                            setConfig={setConfig}
                            cart_width={cart_width}
                            showCartPreview={showCartPreview}
                        />
                        <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                            <NewCustomColorPicker
                                hexColor={cart_bg_color.value}
                                setHexColor={(val) => {
                                    cart_bg_color.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            cart_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "cart_design",
                                    });
                                }}
                                label={"Background"}
                                props={{
                                    ...cart_bg_color,
                                    onBlur: () => cart_bg_color?.runValidation(),
                                }}
                            />
                        </div>
                        {cart_font_family.value !== "Custom Store Font" && (
                            <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                                <FontsSelect
                                    label={"Cart Font"}
                                    options={FONTS}
                                    onChange={(opt) => {
                                        dispatchCartConfig({
                                            payload: {
                                                cart_font_family: opt,
                                            },
                                            isComplex: true,
                                            key: "cart_design",
                                        });
                                        cart_font_family.onChange(opt);
                                    }}
                                    value={cart_font_family.value}
                                />
                            </div>
                        )}
                        <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                            <Checkbox
                                label={"Inherit Fonts from Theme"}
                                checked={cart_font_family.value == "Custom Store Font"}
                                onChange={(e: any) => {
                                    console._log(e);
                                    dispatchCartConfig({
                                        payload: {
                                            cart_font_family: e ? "Custom Store Font" : "Inter",
                                        },
                                        isComplex: true,
                                        key: "cart_design",
                                    });
                                    cart_font_family.onChange(e ? "Custom Store Font" : "Inter");
                                }}
                            />
                        </div>
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Header</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={header_bg_color.value}
                            setHexColor={(val) => {
                                header_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        header_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Background"}
                            props={{
                                ...header_bg_color,
                                onBlur: () => header_bg_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={header_title_color.value}
                            setHexColor={(val) => {
                                header_title_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        header_title_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Title"}
                            props={{
                                ...header_title_color,
                                onBlur: () => header_title_color?.runValidation(),
                            }}
                        />
                    </div>
                    {selected_drawer_template.value == AvailableCartDrawerTemplates.MODERN && (
                        <>
                            <div className={styles.cardSubLabel} style={{ marginBottom: 0 }}>
                                Title Underline
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    gap: 15,
                                    marginBottom: 10,
                                    marginTop: 5,
                                }}
                            >
                                <RadioButton
                                    label={"Solid"}
                                    checked={!header_title_underline_color_gradient_status.value}
                                    onChange={() => {
                                        header_title_underline_color_gradient_status.onChange(false);
                                        dispatchCartConfig({
                                            payload: {
                                                header_title_underline_color_gradient_status: false,
                                            },
                                            isComplex: true,
                                            key: "cart_design",
                                        });
                                    }}
                                />
                                <RadioButton
                                    label={"Gradient"}
                                    checked={header_title_underline_color_gradient_status.value}
                                    onChange={() => {
                                        header_title_underline_color_gradient_status.onChange(true);
                                        dispatchCartConfig({
                                            payload: {
                                                header_title_underline_color_gradient_status: true,
                                            },
                                            isComplex: true,
                                            key: "cart_design",
                                        });
                                    }}
                                />
                            </div>
                            <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                                <NewCustomColorPicker
                                    hexColor={header_title_underline_color.value}
                                    setHexColor={(val) => {
                                        header_title_underline_color.onChange(val);
                                        dispatchCartConfig({
                                            payload: {
                                                header_title_underline_color: val,
                                            },
                                            isComplex: true,
                                            key: "cart_design",
                                        });
                                    }}
                                    label={"Title Underline"}
                                    props={{
                                        ...header_title_underline_color,
                                        onBlur: () => header_title_underline_color?.runValidation(),
                                    }}
                                />
                                {header_title_underline_color_gradient_status.value && (
                                    <>
                                        <NewCustomColorPicker
                                            hexColor={header_title_underline_color_gradient_color.value}
                                            setHexColor={(val) => {
                                                header_title_underline_color_gradient_color.onChange(val);
                                                dispatchCartConfig({
                                                    payload: {
                                                        header_title_underline_color_gradient_color: val,
                                                    },
                                                    isComplex: true,
                                                    key: "cart_design",
                                                });
                                            }}
                                            label={"Title Underline Gradient"}
                                            props={{
                                                ...header_title_underline_color_gradient_color,
                                                onBlur: () =>
                                                    header_title_underline_color_gradient_color?.runValidation(),
                                            }}
                                        />
                                        <RangeSlider
                                            min={0}
                                            max={360}
                                            label={"Gradient Direction"}
                                            value={header_title_underline_color_gradient_direction.value}
                                            onChange={(val) => {
                                                header_title_underline_color_gradient_direction.onChange(val);
                                                dispatchCartConfig({
                                                    payload: {
                                                        header_title_underline_color_gradient_direction: val,
                                                    },
                                                    isComplex: true,
                                                    key: "cart_design",
                                                });
                                            }}
                                            suffix={(header_title_underline_color_gradient_direction.value || 0) + "px"}
                                            output
                                            error={header_title_underline_color_gradient_direction.error}
                                            disabled={!header_title_underline_color_gradient_status?.value}
                                        />
                                    </>
                                )}
                            </div>
                        </>
                    )}
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={header_quantity_color.value}
                            setHexColor={(val) => {
                                header_quantity_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        header_quantity_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Quantity"}
                            props={{
                                ...header_quantity_color,
                                onBlur: () => header_quantity_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={close_button_color.value}
                            setHexColor={(val) => {
                                close_button_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        close_button_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Close Button"}
                            props={{
                                ...close_button_color,
                                onBlur: () => close_button_color?.runValidation(),
                            }}
                        />
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <Select
                            label={"Height"}
                            options={HeaderHeightOptions}
                            onChange={(opt) => {
                                dispatchCartConfig({
                                    payload: {
                                        header_height: opt,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                header_height.onChange(opt);
                            }}
                            value={header_height.value}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Product Card Color</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={cartline_card_bg_color.value}
                            setHexColor={(val) => {
                                cartline_card_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Background"}
                            props={{
                                ...cartline_card_bg_color,
                                onBlur: () => cartline_card_bg_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={cartline_card_text_color.value}
                            setHexColor={(val) => {
                                cartline_card_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Text"}
                            props={{
                                ...cartline_card_text_color,
                                onBlur: () => cartline_card_text_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={cartline_card_save_text_color.value}
                            setHexColor={(val) => {
                                cartline_card_save_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_save_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Save Text"}
                            props={{
                                ...cartline_card_save_text_color,
                                onBlur: () => cartline_card_save_text_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={cartline_card_qty_color.value}
                            setHexColor={(val) => {
                                cartline_card_qty_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_qty_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Quantity"}
                            props={{
                                ...cartline_card_qty_color,
                                onBlur: () => cartline_card_qty_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={cartline_card_discount_bg_color.value}
                            setHexColor={(val) => {
                                cartline_card_discount_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_discount_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Discount Background"}
                            props={{
                                ...cartline_card_discount_bg_color,
                                onBlur: () => cartline_card_discount_bg_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={cartline_card_discount_text_color.value}
                            setHexColor={(val) => {
                                cartline_card_discount_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_discount_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Discount Text"}
                            props={{
                                ...cartline_card_discount_text_color,
                                onBlur: () => cartline_card_discount_text_color?.runValidation(),
                            }}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Product Card Typography</div>
                <FormLayout>
                    <div className={styles.cardSubLabel}>Product Title</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={cartline_card_title_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_title_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                cartline_card_title_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={cartline_card_title_size.error}
                            onBlur={cartline_card_title_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                cartline_card_title_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_title_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={cartline_card_title_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Product Properties</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={cartline_card_properties_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_properties_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                cartline_card_properties_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={cartline_card_properties_size.error}
                            onBlur={cartline_card_properties_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                cartline_card_properties_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_properties_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={cartline_card_properties_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Product Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={cartline_card_price_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_price_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                cartline_card_price_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={cartline_card_price_size.error}
                            onBlur={cartline_card_price_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                cartline_card_price_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_price_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={cartline_card_price_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Product Compare-at Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={cartline_card_compared_price_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_compared_price_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                cartline_card_compared_price_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={cartline_card_compared_price_size.error}
                            onBlur={cartline_card_compared_price_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                cartline_card_compared_price_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_compared_price_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={cartline_card_compared_price_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Product Save Text</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={cartline_card_save_text_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_save_text_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                cartline_card_save_text_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={cartline_card_save_text_size.error}
                            onBlur={cartline_card_save_text_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                cartline_card_save_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        cartline_card_save_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={cartline_card_save_text_style.value}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Footer Color</div>
                <FormLayout>
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        General Footer Layout
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={footer_bg_color.value}
                            setHexColor={(val) => {
                                footer_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Background"}
                            props={{
                                ...footer_bg_color,
                                onBlur: () => footer_bg_color?.runValidation(),
                            }}
                        />
                        {selected_drawer_footer_layout?.value == AvailableCartFooterLayouts.VERTICAL && (
                            <NewCustomColorPicker
                                hexColor={footer_discount_tag_bg_color.value}
                                setHexColor={(val) => {
                                    footer_discount_tag_bg_color.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            footer_discount_tag_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "cart_design",
                                    });
                                }}
                                label={"Discount Tag Background"}
                                props={{
                                    ...footer_discount_tag_bg_color,
                                    onBlur: () => footer_discount_tag_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {selected_drawer_footer_layout?.value == AvailableCartFooterLayouts.VERTICAL && (
                            <NewCustomColorPicker
                                hexColor={footer_discount_tag_text_color.value}
                                setHexColor={(val) => {
                                    footer_discount_tag_text_color.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            footer_discount_tag_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "cart_design",
                                    });
                                }}
                                label={"Discount Tag Text"}
                                props={{
                                    ...footer_discount_tag_text_color,
                                    onBlur: () => footer_discount_tag_text_color?.runValidation(),
                                }}
                            />
                        )}
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        Pricing Text Elements
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={footer_text_color.value}
                            setHexColor={(val) => {
                                footer_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Total Price"}
                            props={{
                                ...footer_text_color,
                                onBlur: () => footer_text_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={footer_compare_at_color.value}
                            setHexColor={(val) => {
                                footer_compare_at_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_compare_at_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Compare-at Price"}
                            props={{
                                ...footer_compare_at_color,
                                onBlur: () => footer_compare_at_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={footer_secondary_text_color.value}
                            setHexColor={(val) => {
                                footer_secondary_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_secondary_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Secondary Text"}
                            props={{
                                ...footer_secondary_text_color,
                                onBlur: () => footer_secondary_text_color?.runValidation(),
                            }}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        Button Design
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={footer_button_bg_color.value}
                            setHexColor={(val) => {
                                footer_button_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Background"}
                            props={{
                                ...footer_button_bg_color,
                                onBlur: () => footer_button_bg_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={footer_button_bg_hover_color.value}
                            setHexColor={(val) => {
                                footer_button_bg_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_bg_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Hover Background"}
                            props={{
                                ...footer_button_bg_hover_color,
                                onBlur: () => footer_button_bg_hover_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={footer_button_text_color.value}
                            setHexColor={(val) => {
                                footer_button_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Text"}
                            props={{
                                ...footer_button_text_color,
                                onBlur: () => footer_button_text_color?.runValidation(),
                            }}
                        />
                        {userShopname && KINNBABY_SHOP_URL.includes(userShopname) && (
                            <NewCustomColorPicker
                                hexColor={footer_custom_shipping_button_color.value}
                                setHexColor={(val) => {
                                    footer_custom_shipping_button_color.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            footer_custom_shipping_button_color: val,
                                        },
                                        isComplex: true,
                                        key: "cart_design",
                                    });
                                }}
                                label={"Secondary Button Text"}
                                props={{
                                    ...footer_custom_shipping_button_color,
                                    onBlur: () => footer_custom_shipping_button_color?.runValidation(),
                                }}
                            />
                        )}
                        <NewCustomColorPicker
                            hexColor={footer_button_text_hover_color.value}
                            setHexColor={(val) => {
                                footer_button_text_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_text_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Hover Text"}
                            props={{
                                ...footer_button_text_hover_color,
                                onBlur: () => footer_button_text_hover_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={footer_button_border_color.value}
                            setHexColor={(val) => {
                                footer_button_border_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_border_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Border"}
                            props={{
                                ...footer_button_border_color,
                                onBlur: () => footer_button_border_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={footer_button_hover_border_color.value}
                            setHexColor={(val) => {
                                footer_button_hover_border_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_hover_border_color: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            label={"Button Hover Border"}
                            props={{
                                ...footer_button_hover_border_color,
                                onBlur: () => footer_button_hover_border_color?.runValidation(),
                            }}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Footer Typography</div>
                <FormLayout>
                    <div className={styles.cardSubLabel}>Footer Total Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={footer_text_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        footer_text_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                footer_text_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={footer_text_size?.error}
                            onBlur={footer_text_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                footer_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={footer_text_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Footer Compare-at Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={footer_compare_at_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        footer_compare_at_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                footer_compare_at_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={footer_compare_at_size.error}
                            onBlur={footer_compare_at_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                footer_compare_at_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_compare_at_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={footer_compare_at_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Footer Secondary Text</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={footer_secondary_text_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        footer_secondary_text_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                footer_secondary_text_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={footer_secondary_text_size.error}
                            onBlur={footer_secondary_text_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                footer_secondary_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_secondary_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={footer_secondary_text_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Footer CTA</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={footer_button_cta_text_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_cta_text_size: +value,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                                footer_button_cta_text_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={footer_button_cta_text_size.error}
                            onBlur={footer_button_cta_text_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font Style"}
                            onChange={(val) => {
                                footer_button_cta_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_cta_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            value={footer_button_cta_text_style.value}
                        />
                        <RangeSlider
                            min={0}
                            max={100}
                            label={"Border Radius"}
                            value={footer_button_radius.value}
                            onChange={(val) => {
                                footer_button_radius.onChange(+val);
                                dispatchCartConfig({
                                    payload: {
                                        footer_button_radius: +val,
                                    },
                                    isComplex: true,
                                    key: "cart_design",
                                });
                            }}
                            output
                            suffix={(footer_button_radius.value || 0) + "px"}
                            error={footer_button_radius.error}
                        />
                    </div>
                </FormLayout>
            </div>
        </>
    );
};

export default CartDesignCard;
